import styled from 'styled-components';

interface StyledProps {
  opacity: number;
  isVisible: boolean;
}

const AnimatedDiv = styled.div.attrs<any, StyledProps>((): any => ({}))`
  & > * {
    opacity: ${({ opacity }) => opacity};
    pointer-events: ${({ isVisible }) => (isVisible ? 'inherit' : 'none')};
    z-index: 1;
  }
`;

export default AnimatedDiv;
